import { ConditionParams } from "@omni/types/utils/productConfiguration";

const paintProductSKUs = [
    "141950",
    "141947",
    "141949",
    "141946",
    "141948",
    "141945",
    "141944",
    "104302",
    "104304",
    "104299",
    "104301",
    "104296",
    "104298",
    "917745",
    "184236",
    "184238",
    "917721",
    "917723",
    "1165644",
    "1165588",
    "1165663",
    "1165646",
    "1165647",
    "1165664",
    "1165671",
    "1165661",
    "1165681",
    "1165675",
    "1165665",
    "1165649",
    "1165683",
    "1165685",
    "1165677",
    "1165679",
    "1165676",
    "1165666",
    "1165668",
    "1165691",
    "1165684",
    "1165678",
    "1165673",
    "1165682",
    "1165674",
    "1165667",
    "1165650",
    "1165692",
    "1165686",
    "1165648",
    "1165645",
    "1165589",
    "1165689",
    "1165711",
    "1165662",
    "1165669",
    "1165688",
    "1165680",
    "1165693",
    "1165687",
    "1165694",
    "1165672",
    "1165670",
    "1165701",
    "1165590"
];

export const PaintConfiguratorCondition = ({ sku }: ConditionParams) => {
    return !!sku && paintProductSKUs.includes(sku);
};
